import { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { dispatch } from 'store'
import { aiAvatarSelectors } from 'store/features/aiAvatar/selectors'
import { aiAvatarThunks } from 'store/features/aiAvatar/thunks'
import { voiceCatalogSelectors } from 'store/features/voiceCatalog/selectors'
import { voiceCatalogThunks } from 'store/features/voiceCatalog/thunks'
import {
  useGetTtsSpeakers,
  usePremiumVoiceHandler
} from 'containers/SubSidebar/shared/Voices/hooks'
import { AVATAR_TTS_VOICE_MODEL } from 'consts/tts'

export const useAvatarVoice = () => {
  const languageOptions = useSelector(
    voiceCatalogSelectors.avatarLanguageOptionsData
  )
  const isLanguageOptionsLoading = useSelector(
    voiceCatalogSelectors.isAvatarLanguageOptionsLoading
  )

  const langCode = useSelector(aiAvatarSelectors.voiceLangCode)
  const speakerId = useSelector(aiAvatarSelectors.voiceSpeakerId)
  const speed = useSelector(aiAvatarSelectors.voiceSpeed)

  const { ttsSpeakers, isSpeakersLoading } = useGetTtsSpeakers(
    langCode,
    AVATAR_TTS_VOICE_MODEL
  )

  const { handleVoiceSelection } = usePremiumVoiceHandler({
    speakers: ttsSpeakers || [],
    onVoiceSelect: (id: number) => {
      dispatch(aiAvatarThunks.setVoiceSpeakerId(id))
    }
  })

  const onChooseLanguageOption = useCallback(
    (newLangCode: string | number) => {
      if (newLangCode !== langCode) {
        dispatch(aiAvatarThunks.setVoiceLanguage(newLangCode as string))
      }
    },
    [langCode]
  )

  const onChooseSpeakerOption = useCallback(
    (id: number) => {
      handleVoiceSelection(id)
    },
    [handleVoiceSelection]
  )

  const onChooseSpeedOption = useCallback(
    (value: number) => {
      if (value !== speed) {
        dispatch(aiAvatarThunks.setVoiceSpeed(value))
      }
    },
    [speed]
  )

  useEffect(() => {
    dispatch(voiceCatalogThunks.getAvatarLanguageOptions())
    dispatch(
      voiceCatalogThunks.getSpeakersPerLangCode(
        langCode,
        undefined,
        AVATAR_TTS_VOICE_MODEL
      )
    )
  }, [langCode])

  return {
    languageOptions,
    isLanguageOptionsLoading,
    langCode,
    speakerId,
    speed,
    ttsSpeakers,
    isSpeakersLoading,
    onChooseLanguageOption,
    onChooseSpeakerOption,
    onChooseSpeedOption
  }
}
